<template>
    <div class="bg-white p-2 m-2 border rounded flex cursor-pointer">

        
        <div :class="{'w-8 h-8':supPost, 'w-14 h-14':!supPost}">
            <img v-if="feed.profileImage" class="w-full h-full rounded-full" :src="imageLink(feed.profileImage)" alt="">
        </div>

        <div class="w-full flex-1 pl-2">

            <div class="w-full flex">

                <div class="flex-1 flex flex-col">
                    <span v-if="feed.accountName" class="text-lg font-medium">{{ ( feed.accountName )}}</span>
                    <span v-if="feed.account" class="text-lg font-medium" :class="{'text-gray-600 text-sm':feed.accountName}">{{ (feed.accountName ? "@"  + feed.account : feed.account)}}</span>
                </div>

                <div v-if="loading" class="text-center bg-white p-1">
                    <svg  aria-hidden="true" class="w-6 h-6 m-auto text-gray-200 animate-spin fill-blue-600" viewBox="0 0 100 101" fill="black" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"  fill="#e5e7eb"/>
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="black"/>
                    </svg>
                </div>
                <div class="group" v-else-if="menu">
                    <svg  class="rotate-90 cursor-pointer w-[28px] h-[28px] text-gray-800 " aria-hidden="true" 
                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="black" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-width="3" 
                    d="M12 6h.01M12 12h.01M12 18h.01"/>
                    </svg>
                 
                    <div class="absolute z-10 hidden group-hover:block">
                        <ul class="bg-white h border rounded">
                        <li class="cursor-pointer px-2 py-1 
                        w-40 hover:bg-gray-100" @click="copyToClipboard(feed.link)" > Copy Link </li>
                        <li class="cursor-pointer px-2 
                        py-1 w-40 hover:bg-gray-100" @click="testWebHook(feed)" > Test WebHook </li>
                        </ul>
                    </div>
                </div>

            </div>
          
            <span class="flex-1 m-2 text-lg break-word" :class="{'line-clamp-4':!ReadMore && feed.text && feed.text.length > 120}">
                {{ feed.text }}
            </span>

            <span v-if="feed.text&&feed.text.length > 120" class="text-blue-500" @click="ReadMore = !ReadMore">{{ReadMore?'Read Less':'Read More'}}</span>

            <span v-if="feed.subtext" class="m-2 text-gray-600 text-sm break-word" :class="{'line-clamp-4': !subtextReadMore &&feed.subtext &&feed.subtext.length > 200}">
                {{ feed.subtext }}
            </span>

            <span v-if="feed.subtext&&feed.subtext.length > 200" class="text-blue-500" @click="subtextReadMore = !subtextReadMore">{{subtextReadMore?'Read Less':'Read More'}}</span>

            <slot v-if="feed.supPost"></slot>
            <div v-else class="">

                <img crossorigin="anonymous" v-if="feed.attachedImage" style="min-height: 350px; max-height: 650px;" 
                class=" max-w-full mx-auto my-2 min-h-52 bg-gray-500 border border-gray-50 rounded-md" :src="imageLink(feed.attachedImage)" alt=""/>

                <video style="min-height: 350px; max-height: 600px;" :poster="feed.attachedVideoPoster" v-if="feed.attachedVideo" controls 
                class="mx-auto bg-black my-2 w-full rounded-md" 
                :src="feed.attachedVideo" alt=""></video>

            </div>

            <span class="text-gray-500 block my-1">{{ moment(feed.pubDate) }}</span>

        </div>

    </div>
</template>
  
<script>
import moment from 'moment'

export default {
    name: 'FeedItem',
    props:['feed','menu','supPost'],
    components: {

    },
    async mounted(){

    },
    data () {
        return {
            loading:false,
            ReadMore:false,
            subtextReadMore:false
        }
    }, 
    methods: {
        copyToClipboard(value){
            // Copy the text inside the text field
            navigator.clipboard.writeText(value);
        },
        async testWebHook(data){
            try {
                this.loading = true;
                const res = await this.$store.state.axiosInstance.get(this.$store.state.API_ENDPOINT + '/v1/callWebHook/'+data._id,{
                    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
                });
                this.loading = false;
                if(res.data && res.data.success){
                    this.$store.state.toastr.open({timeOut:5000, type:"success", 
                    title:'Success ', text: 'WebHook Tested successfully'});
                } else {
                    this.$store.state.toastr.open({timeOut:5000, type:"error", 
                    title:'Failed ', text: res.data.message || 'Webhook test failed'});
                }
            } catch (error) {
                this.loading = false;
                this.$store.state.toastr.open({timeOut:5000, type:"error", 
                title:'Failed ', text: error.message ||'Webhook test failed'});
            }
        },
        moment(time){
            return moment(time).format("hh:mm A MMM DD,YYYY")
        },
        imageLink(link){
            if(link.includes('twimg.com')){ // twitter images
                return link
            }else{ 
                return this.$store.state.API_ENDPOINT + '/v1/cors-file?link=' + encodeURIComponent(link)
            }
        }
    }
}
</script>
 
<style>
 .break-word{ word-break: break-word}
</style>



// WEBPACK FOOTER //
// src/components/FeedItem.vue